import { Model } from 'vuex-orm';

import AppMembership from '../appMembership/model';
import AppPackage from '../package/model';
import Role from '../role/model';
import UserMembership from '../userMembership/model';
import Category from '../category/model';

export default class App extends Model {
  static entity = 'apps';

  static fields() {
    return {
      id: this.attr(null),
      name: this.attr(''),
      machine_name: this.attr(''),
      version: this.attr(''),
      status: this.attr(''),
      app_memberships: this.hasMany(AppMembership, 'app_id'),
      user_memberships: this.hasMany(UserMembership, 'app_id'),
      packages: this.hasMany(AppPackage, 'app_id'),
      roles: this.hasMany(Role, 'app_id'),
      settings: {
        billing_categories: this.hasMany(Category, 'app_id'),
        pto_categories: this.hasMany(Category, 'app_id'),
      },
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/app/model.js